module.exports = __webpack_public_path__ + "static/assets/2d6d0c37518eaec413b4b0b5a8257d50.svg";